import * as am4charts from '@amcharts/amcharts4/charts';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4plugins from "@amcharts/amcharts4/plugins/sunburst";
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { Component, NgZone, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { NavigatorService } from '../../services/navigator.service';
import { SondaggioRispostaService } from '../../services/sondaggio/sondaggioRisposta.service';
import { CollaboratoreDTO } from '../../shared/dto/domain/collaboratore';
import { PieValuesDTO } from '../../shared/dto/pie_values/pieValues';
import { SondaggioDTO, SondaggioOptionDTO } from '../../shared/dto/sondaggi/sondaggio';
import { SondaggioOptionStatisticaDTO } from '../../shared/dto/sondaggi/sondaggioOptionStatisticaDTO';
import { SondaggioRispostaDTO } from '../../shared/dto/sondaggi/sondaggioRisposta';

@Component({
  selector: 'app-risultati-sondaggio',
  templateUrl: './risultati-sondaggio.component.html',
  styleUrls: ['./risultati-sondaggio.component.scss']
})
export class RisultatiSondaggioComponent implements OnInit {

  locale: string = "it";

  dataSource: any;
  displayedColumns: any;
  
  risposteTot: number;
  sondaggio: SondaggioDTO;
  collaboratori: any;
  
  statistiche: SondaggioOptionStatisticaDTO[] = [];

  constructor(
    private zone: NgZone,
    private navigatorService: NavigatorService,
    private activeRoute: ActivatedRoute,
    private sondaggioRispostaService: SondaggioRispostaService,
  ) {
    this.displayedColumns = ['opzione', 'risposte', 'votanti'];
  }

  ngOnInit() {
    const sondaggioId = Number(this.activeRoute.snapshot.paramMap.get("id"));

    this.navigatorService.collaboratore.subscribe((res: CollaboratoreDTO) => {
      this.sondaggioRispostaService.readRisposteSondaggio(sondaggioId).subscribe((res: SondaggioRispostaDTO) => {
        this.sondaggio = res.sondaggio;

        this.risposteTot = this.sondaggio?.risposte?.length ?? 0;

        this.statistiche = this.sondaggio.options.map((o: SondaggioOptionDTO) => {
          let collaboratori: CollaboratoreDTO[] = this.sondaggio.risposte.filter(r => r.sondaggioOption.id == o.id).map(r => r.collaboratore);

          let ret: SondaggioOptionStatisticaDTO = {
            option: o,
            collaboratore: collaboratori ?? [],
            totale: collaboratori.length ?? 0,
            peso: (this.risposteTot != 0) ? (collaboratori.length / this.risposteTot) * 100 : 0
          }
          return ret;
        });

        this.dataSource = new MatTableDataSource(this.statistiche);
        if(this.risposteTot > 0) {
          this.drawChart();
        }
      });
    });
  }

  private am4themes_myTheme(target) {
    if (target instanceof am4charts.PieSeries) {
      let colorSet = new am4core.ColorSet();
      colorSet.step = 4;
      colorSet.baseColor = new am4core.Color({
        r: 50,
        g: 165,
        b: 237
      });
      target.colors = colorSet;

      target.labels.template.text = "{key}: {value} %";
      target.slices.template.tooltipText = "{key}: {value} %";
      target.legendSettings = new am4charts.LegendSettings();
      target.legendSettings.labelText = "{key}: {value} %";
      target.legendSettings.valueText = " ";
    } else if (target instanceof am4plugins.Sunburst) {
      let colorSet = new am4core.ColorSet();
      colorSet.step = 4;
      colorSet.baseColor = new am4core.Color({
        r: 50,
        g: 165,
        b: 237
      });
      target.colors = colorSet;
    }
  }

  private drawChart() {
    this.zone.runOutsideAngular(() => {
      am4core.addLicense("CH299766748");
      am4core.useTheme(am4themes_animated);
      am4core.useTheme(this.am4themes_myTheme);

      let chart = am4core.create("grafico", am4charts.PieChart);
      chart.paddingRight = 20;
      let title = chart.titles.create();
      // title.text = "Grafico numero risposte";
      title.fontSize = 25;
      title.margin(10, 0, 0, 0);

      var array: PieValuesDTO[] = this.statistiche.map(r => ({ key: r.option.name, value: r.peso }));
      var newArr = [];
      // eliminazione delle attività duplicate:
      array.forEach(function (a) {
        if (!this[a.key]) {
          this[a.key] = { key: a.key, value: 0 };
          newArr.push(this[a.key]);
        }
        this[a.key].value += a.value;
      }, Object.create(null));

      chart.data = newArr;

      // Add and configure Series
      let pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "key";
      //tick disabilitati
      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;

      //legenda
      chart.legend = new am4charts.Legend();
      chart.legend.useDefaultMarker = true;
      chart.legend.margin(0, 0, 20, 0);
      chart.legend.maxHeight = 400;
      chart.legend.scrollable = true;
      let marker = chart.legend.markers.template.children.getIndex(0);
      marker.strokeWidth = 2;
      marker.strokeOpacity = 1;
      marker.stroke = am4core.color("#ccc");
    })
  }

  isSondaggioExpired() {
    const now = moment();
    const dataScadenza = moment(this.sondaggio?.dataScadenza);
    return now.isAfter(dataScadenza)
  }

  listaCollab(o: any): string {
    return o?.collaboratore?.map((c: any) => `${c.nome} ${c.cognome}`).join(', ') || '';
  }

}

